import { type Authorization, AuthorizationSchema, type Credentials } from '@scoring/types';
import { queryKeys } from '../../queries/queryKeys';
import { post } from '../../queries';
import { useApiMutation } from '../../queries/useApiMutation';

export const useLoginMutation = () => {
    const mutation = useApiMutation<{ credentials: Credentials }, LoginResponse, Authorization>({
        invalidateQueryOnMutate: true,
        queryKey: queryKeys.auth(),
        mutationFn: ({ credentials }) => post(`identity/login`, credentials, AuthorizationSchema),
        transform: (response) => response,
    });

    return { ...mutation };
};

type LoginResponse = Authorization;
